import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { PaymentStore } from '../../event/service/payment.store';
import { FlashMessagesService } from '../flash-messages/service/flash.messages.service';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { EventStore } from '../../event/service/event.store';
import { OnyxEvent } from '../../event/models/event';
import { PaymentStatus } from 'app/event/models/payment-status.enum';

@Injectable()
export class FinalPaymentAuthorizedGuard implements CanActivate {

  constructor(
    private paymentStore: PaymentStore,
    private flashMessagesService: FlashMessagesService,
    private authenticationStore: AuthenticationStore,
    private eventStore: EventStore
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let activate = true;

    if (!this.isMultiVendor()) {
      let onyxEvent: OnyxEvent = new OnyxEvent();
      this.eventStore.selectedEvent.subscribe(value => {
        onyxEvent = new OnyxEvent(value);
      });

      this.paymentStore.getVendorFinalPayment(onyxEvent.eventProperty.eventPartyId).take(1).subscribe(lastFinalPayment => {
        if (Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId
          && !this.paymentStore.isPaymentRequestedOrRequestResent(lastFinalPayment))
          && !this.paymentStore.isPaymentRejected(lastFinalPayment)
          && lastFinalPayment.status !== PaymentStatus.REJECTED_WF_APPROVAL) {
          this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE',
            'Cannot edit an event with a final payment already authorized');
          activate = false;
        }
      });
    }

    return activate;
  }

  isMultiVendor() {
    return this.authenticationStore.hasPermission('MultiVendor');
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/final-payment-authorized.guard.ts